/**
 * Vincent B629 (Eric 2026-07-30 SPEC STRICK PROD) — Source de vérité UNIQUE
 * pour les thèmes de formation, en FRANÇAIS uniquement, partout dans l'app
 * (Importer une vidéo / Importer un fichier / édition inline de l'Explorateur).
 *
 * Vincent : « Ces thèmes doivent être indiqués en français uniquement, autant
 * ici que partout ailleurs, notamment lors de l'importation du fichier
 * (Texte ou Vidéo). »
 *
 * La `value` (identifiant technique, envoyée à l'API) reste EN pour ne pas
 * casser les recherches / filtres / index existants côté backend. Seuls les
 * libellés visibles sont en FR.
 */

// Tâche 1387 (Eric 2026-06-30) — Eric RENVERSE la décision B629 : les thèmes
// doivent désormais être traduits en version anglaise. Vincent avait exigé
// l'inverse (« en français uniquement, partout »), parce que l'ancien système
// affichait « Sales » et « Compliance » dans une interface française. Le
// problème n'était donc pas la traduction, c'était l'absence de libellé
// français. On garde donc l'acquis de B629 — la `value` technique reste
// anglaise, les libellés français sont soignés — et on ajoute la colonne
// anglaise sur la MÊME ligne.
export const TRAINING_THEMES = [
  { value: "general", label: "Général", label_en: "General" },
  { value: "sales", label: "Vente", label_en: "Sales" },
  { value: "procedures", label: "Procédures", label_en: "Procedures" },
  { value: "compliance", label: "Conformité", label_en: "Compliance" },
  { value: "product", label: "Produit", label_en: "Product" },
  { value: "onboarding", label: "Intégration", label_en: "Onboarding" },
];

const LABEL_BY_VALUE = Object.fromEntries(
  TRAINING_THEMES.map((t) => [t.value, t.label])
);
const LABEL_EN_BY_VALUE = Object.fromEntries(
  TRAINING_THEMES.map((t) => [t.value, t.label_en])
);

/** Libellé d'un thème dans la langue de l'écran. */
export function themeLabelFor(theme, lang) {
  return (lang === "en" ? theme.label_en : theme.label) || theme.label;
}

/**
 * Retourne le libellé FR d'un thème, avec fallback intelligent :
 * - Si `value` correspond à un des thèmes canoniques → libellé FR.
 * - Sinon (thème custom ou legacy), renvoie la value avec 1re lettre
 *   capitalisée, ou "Général" si vide.
 */
export function trainingThemeLabel(value, lang) {
  const en = lang === "en";
  if (!value) return en ? "General" : "Général";
  const table = en ? LABEL_EN_BY_VALUE : LABEL_BY_VALUE;
  const canonical = table[String(value).toLowerCase()];
  if (canonical) return canonical;
  // Thème saisi par l'organisation : c'est une donnée, on ne la traduit pas.
  const s = String(value).trim();
  return s.charAt(0).toUpperCase() + s.slice(1);
}
